<template>
  <div class="form-check">
    <input v-model="inputModel" :value="value" type="radio" :name="name" :id="id" :disabled="disabled"
           class="form-check-input">
    <label v-if="label" class="form-check-label" :for="id">{{ label }}</label>
  </div>
</template>
<script lang="ts">
import {defineComponent, type PropType} from 'vue';
import {AbstractInputComponent} from '@shared/components/abstracts';
import {CommonNs} from "@shared/types";

export default defineComponent({
  name: 'RadioElement',
  extends: AbstractInputComponent,
  emits: ['update:modelValue'],
  props: {
    type: {
      type: String as unknown as PropType<CommonNs.InputType>,
      required: false,
      default:"radio"
    },
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    modelValue: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    inputModel: {
      get(): string {
        return this.modelValue;
      },
      set(value: string): void {
        this.$emit('update:modelValue', value);
      },
    },
  },
});
</script>
<style lang="scss" scoped>

.form-check {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0;
  min-height: 16px;
  padding-left: 15px;
}

.form-check-label {
  font-size: var(--fs-14);
  color: var(--text-dark);
  margin-left: 10px;
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}

.form-check-input {
  cursor: pointer;
  margin-top: 0;
  margin-left: -15px !important;
  background-color: var(--form-check-radio-bg);
  border: 1px solid var(--form-check-radio-border);

  &[type=checkbox]{
    border-radius: $br-xs;
  }

  &:checked {
    background-color: var(--accent-100);
    border-color: var(--accent-100);
  }

  &:checked:disabled {
    background-color: var(--text-neutral);
    border-color: var(--text-neutral);
    cursor: not-allowed;
  }

  &:disabled {
    cursor: default !important;
  }

  &:focus,
  &:hover {
    box-shadow: var(--shadow-outline) !important;
    cursor: pointer;
  }

}

.icon{
  margin-right: 0;
  width: 14px;
  height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--text-neutral);
  font-size: var(--fs-14);
}
.color{
  width: 14px;
  height: 14px;
  border-radius: $br-xs;
  &.palette-purple-light{
    background-color: var(--palette-purple-color-light);
  }
}
</style>
